import { IonLoading } from "@ionic/react"
import { AppContext } from "context/app.context";
import React, { useContext } from "react"

const Loading = () => {

    const { isLoading, setIsLoading } = useContext(AppContext);

    return (
        <IonLoading cssClass='my-custom-class' isOpen={isLoading} message={'Please wait...'}
            onDidDismiss={() => setIsLoading(false)}
        />
    )
}

export default Loading;